import { faEnvelope, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import LogoutIcon from "../../../../assets/images/graphics/logout-icon.svg";
import "./FloatingMenu.css";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useCompanyDetails } from "../../../../hooks/useCompanyDetails";
import { getBusinessOrderEmail } from "../../../../utils/businessOrderEmail";

type FloatingMenuProps = {
  logoutButton: boolean;
  homeButton: boolean;
  isBusiness: boolean;
};
const FloatingMenu = ({
  logoutButton,
  homeButton,
  isBusiness,
}: FloatingMenuProps) => {
  const { logout } = useAuthUser();
  const { data: companyDetails } = useCompanyDetails();
  const businessOrderEmail = getBusinessOrderEmail(companyDetails);
  return (
    <div className="floating-menu">
      {homeButton && (
        <Link to="/" className="circle-btn" title="Return to Home">
          <FontAwesomeIcon
            icon={faHome}
            style={{ color: "#ffffff", width: "50%", height: "50%" }}
          />
        </Link>
      )}{" "}
      {isBusiness && (
        <a
          href={`mailto:${businessOrderEmail}`}
          className="circle-btn"
          title="Contact us about your order"
        >
          <FontAwesomeIcon
            icon={faEnvelope}
            style={{ color: "#ffffff", width: "50%", height: "50%" }}
          />
        </a>
      )}
      {logoutButton && (
        <button className="circle-btn" title="Log out" onClick={logout}>
          <img
            src={LogoutIcon}
            alt="logout icon"
            style={{ width: "60%", height: "60%" }}
          />
        </button>
      )}
    </div>
  );
};

export default FloatingMenu;
